/**
 * Procesos documentados — enlazar con Notion cuando exista URL.
 * REACT_APP_NOTION_* opcionales en .env del frontend.
 */
export const ADMIN_PROCESS_LINKS = {
  chk001: {
    code: 'CHK-001',
    label: 'Empaque y preparación',
    repoDoc: 'CHK-001_EMPAQUE_PREPARACION_PEDIDO.md',
    notionUrl: process.env.REACT_APP_NOTION_CHK001 || ''
  },
  sop_checkout: {
    code: 'SOP-001',
    label: 'Checkout y pagos',
    repoDoc: 'SOP-001_CHECKOUT_PAGOS_MERCADOPAGO.md',
    notionUrl: process.env.REACT_APP_NOTION_SOP001 || ''
  },
  sop_facturacion: {
    code: 'FLUJO',
    label: 'Facturación Numbers',
    repoDoc: 'PLAN_IMPLEMENTACION_FACTURACION_JAVILAND.md',
    notionUrl: process.env.REACT_APP_NOTION_FACTURACION || ''
  },
  matriz_proveedores: {
    code: 'MATRIZ',
    label: 'Proveedores y SKUs',
    repoDoc: 'MATRIZ_PROVEEDORES_JAVILAND_2026.md',
    notionUrl: process.env.REACT_APP_NOTION_PROVEEDORES || ''
  }
};
